// action type strings
import * as actionTypes from '../../actionTypes';

export function updateJobRequest(jobRequest) {
  return {
    type: actionTypes.UPDATE_JOB_REQUEST,
    jobRequest
  };
}


// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/jobrequestsAdmin.js